import { render, staticRenderFns } from "./user-dash-contacts.vue?vue&type=template&id=700b8be9&"
import script from "./user-dash-contacts.vue?vue&type=script&lang=js&"
export * from "./user-dash-contacts.vue?vue&type=script&lang=js&"
import style0 from "./user-dash-contacts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports